import React, { useEffect } from "react";

export default function CollapsableCardScript() {
  useEffect(() => {
    if (window) {
      window["collapseAllOtherExcept"] = (selectedCardNum) => {
        // search for all the cards except selected card and remove the "open" class from title and add the "collapsed" class in card content
        let cards = document.getElementsByClassName(`accordion-title`);
        cards = [...cards];
        if (cards.length > 0) {
          cards.forEach((_, index) => {
            const curCardNum = index + 1;
            if (curCardNum != selectedCardNum) {
              const card = document.getElementsByClassName(
                `card-title-${curCardNum}`
              )[0];
              card.classList.remove("open");
              const cardContent = document.getElementsByClassName(
                `card-item-${curCardNum}`
              )[0];
              cardContent.classList.add("collapsed");
            }
          });
        }
      };

      window["toggleSelectedCard"] = (cardNumber) => {
        let card = document.getElementsByClassName(
          `card-title-${cardNumber}`
        )[0];

        const allClasses = [...card.classList];
        //   if card is alreay opened closs all cards else close all cards except the selected card
        if (allClasses.indexOf("open") >= 0) {
          // it means card is open
          //close all cards
          window.collapseAllOtherExcept("");
        } else {
          card.classList.add("open");
          const cardContent = document.getElementsByClassName(
            `card-item-${cardNumber}`
          )[0];
          cardContent.classList.remove("collapsed");
          window.collapseAllOtherExcept(cardNumber);
        }
      };
    }
  }, []);
  return <div className="script"></div>;
}
